import {BiUser} from 'react-icons/bi';
import {AiOutlineHome} from 'react-icons/ai';
import {AiOutlineMessage} from 'react-icons/ai';
import {BiBook} from 'react-icons/bi';
import {RiServiceLine} from 'react-icons/ri';



const data = [
    {id:1 , link : '#' , icon : <AiOutlineHome/>},

    {id:2 , link : '#about' , icon : <BiUser/>},
    {id:3, link : '#experience', icon : <BiBook/>},
    
    {id:4 , link : '#portfolio' , icon : <RiServiceLine/>},

    {id:5 , link : '#contact' , icon : <AiOutlineMessage/>}

]

export default data;